import { medicareApiClient } from 'clients/medicareApiClient'
import { useEffect, useRef, useState } from 'react'
import { Status } from 'redux/helpers/claimCase'

/**
 * Fetches the OIF cookies after claims summary cases have been fetched. This is key
 * in making sure we get the reqToken to the backend before trying to fetch the OIF
 * cookies
 *
 * @param summaryFetchStatus Status of the current summary fetch status --- usually pull
 * @returns
 */
export const useFetchOifCookiesOnLoad = (summaryFetchStatus: Status) => {
  const fetchedCookies = useRef(false)
  const [loadingState, setLoadingState] = useState<'finished' | 'error' | 'loading' | 'idle'>('idle')

  useEffect(() => {
    if (fetchedCookies.current) {
      return
    }

    if (summaryFetchStatus === Status.FINISHED) {
      const doOifFetch = async () => {
        setLoadingState('loading')
        try {
          await medicareApiClient.authenticationApi.getOIFCookies()
          setLoadingState('finished')
        } catch (e: unknown) {
          setLoadingState('error')
        }
      }
      fetchedCookies.current = true
      doOifFetch()
    }
  }, [summaryFetchStatus, setLoadingState])

  return loadingState
}
